import script from "./compNewsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./compNewsTable.vue?vue&type=script&setup=true&lang=js"

import "./compNewsTable.vue?vue&type=style&index=0&id=6e48c4af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e48c4af"]])

export default __exports__